export enum DetectorType {
  Unknown = -1,
  RegToString = 0,      // 根據正則檢測
  DefineId = 1,         // 根據 dom id 檢測
  // Size = 2,             // 根據窗口尺寸檢測
  DateToString = 3,     // 根據 Date.toString 檢測
  FuncToString = 4,     // 根據 Function.toString 檢測
  Debugger = 5,         // 根據斷點檢測，僅在 ios chrome 真機情況下有效
  Performance = 6,      // 根據 log 大數據性能檢測
  DebugLib = 7,         // 檢測第三方調試工具
}
